import { UsersListItemDto } from "@green0meter/api-client";
import React, { FC } from "react";

import { ConfirmationModal } from "@components/common";
import { useBlockUser } from "@api";
import { useUserStore } from "@store/user";

interface BlockUserConfirmation {
  user: UsersListItemDto;
  onCancel: () => void;
}

const BlockUserConfirmation: FC<BlockUserConfirmation> = ({ user, onCancel }) => {
  const { user: currentUser } = useUserStore();
  const { blockUser, blockUserEnabled } = useBlockUser(currentUser);

  const handleBlockUser = (): void => {
    blockUser(user.id);
    onCancel();
  };

  return (
    blockUserEnabled && (
      <ConfirmationModal
        open
        title="Confirm your action"
        description={`Are you sure you want to remove ${user.firstName} ${user.lastName}`}
        onClose={onCancel}
        onConfirm={handleBlockUser}
      />
    )
  );
};

export default BlockUserConfirmation;
